export function populateAbout(jsonData){
    aboutData = jsonData;
    
    aboutHeadingText = jsonData.about.data.section_heading.value;
    aboutSubtext = jsonData.about.data.section_text.value;

    aboutSectionTwo = $(".about__section-two");

    if(!$(document).find(".preview").hasClass("hidden")){
        $("h2#aboutHeadingText").html(aboutHeadingText.replace(/\n/g, "<br>"));
        $("p#aboutSubtext").html(aboutSubtext.replace(/\n/g, "<br>"));    
        
        if(aboutSubtext.length > 520){
            aboutSectionTwo.css("position", "relative");
            aboutSectionTwo.find(".readAboutSubtext").removeClass("hidden");
        }
    }
    else{                            
        $("textarea#aboutHeadingText").html(aboutHeadingText);
        $("textarea#aboutSubtext").html(aboutSubtext);
    } 
}